import Reflux from 'reflux';
import NProgress from 'nprogress';
import http from '../../helper/ajax';

const SidebarAction = Reflux.createActions([
  'getSidebarWidget',
  'publishAllWidget',
]);

NProgress.configure({ easing: 'ease', speed: 1000 });

SidebarAction.getSidebarWidget.preEmit = (data) => {
  NProgress.start();
  http.post('load_sidebar', data).end((error, res) => {
    if (res) {
      NProgress.done();
      SidebarAction.publishAllWidget(res.text);
    }
  });
};

export default SidebarAction;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/action/sidebarAction.js
 **/